var $f648321ae94b8ad5$exports = {};
$f648321ae94b8ad5$exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};


export {$f648321ae94b8ad5$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
